import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getTwoLetterCountryCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_COUNTRY_ISO_CODE";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { getPrimaryCountriesIsoToCountryName } from "../consts/PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME";
import { getFullLanguageName } from "../consts/THREE_TO_FULL_LANGUAGE_NAME";
import { isNotUndefined } from "../typescriptUtils";
var THREE_LETTER_PRIMARY_COUNTRY_CODES = function THREE_LETTER_PRIMARY_COUNTRY_CODES(strictLocalize) {
  return _objectSpread(_objectSpread({}, getPrimaryCountriesIsoToCountryName(strictLocalize)), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ISO3166Alpha3.DEU, "Deutschland"), ISO3166Alpha3.ITA, "Italia"), ISO3166Alpha3.ESP, "España"), ISO3166Alpha3.PRT, "Portugal"), ISO3166Alpha3.USA, "United States"));
};
var defaultCountryLanguage = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Language.DEU, ISO3166Alpha3.DEU), Language.ITA, ISO3166Alpha3.ITA), Language.SPA, ISO3166Alpha3.ESP), Language.POR, ISO3166Alpha3.PRT), Language.ENG, ISO3166Alpha3.USA), Language.FRA, ISO3166Alpha3.FRA), Language.NLD, ISO3166Alpha3.NLD), Language.SWE, ISO3166Alpha3.SWE), Language.DAN, ISO3166Alpha3.DNK);
export var convertLocaleToCountryLocaleString = function convertLocaleToCountryLocaleString(localeKey) {
  var _getTwoLetterLanguage2;
  var language = localeKey.language,
    countryCode = localeKey.country;
  if (!language) {
    return undefined;
  }
  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  if (countryCode && defaultCountryLanguage[language] !== countryCode) {
    var _getTwoLetterLanguage, _getTwoLetterCountryC;
    return ((_getTwoLetterLanguage = getTwoLetterLanguageCode(language)) === null || _getTwoLetterLanguage === void 0 ? void 0 : _getTwoLetterLanguage.toLowerCase()) + "-" + ((_getTwoLetterCountryC = getTwoLetterCountryCode(countryCode)) === null || _getTwoLetterCountryC === void 0 ? void 0 : _getTwoLetterCountryC.toLowerCase());
  }
  return (_getTwoLetterLanguage2 = getTwoLetterLanguageCode(language)) === null || _getTwoLetterLanguage2 === void 0 ? void 0 : _getTwoLetterLanguage2.toLowerCase();
};
export var languageAndCountryText = function languageAndCountryText(language, strictLocalize, countryCode) {
  return "".concat(getFullLanguageName(language), " (").concat(
  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  THREE_LETTER_PRIMARY_COUNTRY_CODES(strictLocalize)[countryCode !== null && countryCode !== void 0 ? countryCode : ISO3166Alpha3.USA], ")");
};
export var languageWithCountryOptions = function languageWithCountryOptions(availableLocale, strictLocalize) {
  return availableLocale.map(function (localeKey) {
    var language = localeKey.language,
      countryCode = localeKey.country;
    if (language === undefined) {
      return undefined;
    }
    var convertedLocale = convertLocaleToCountryLocaleString(localeKey);
    if (convertedLocale === undefined) {
      return undefined;
    }
    return {
      label: languageAndCountryText(language, strictLocalize, countryCode),
      value: convertedLocale
    };
  }).filter(isNotUndefined);
};